module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_250_Inactive@1x-b486f2e7d382a2af38c0b1666899d486.png";